import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { Toast, ToastComponent } from '../../shared/toast/toast.component';
import { GridConfig } from '../../shared/dynamic-grid/grid-model/grid-config.model';
import { API_ENDPOINTS } from '../../shared/constants/apiEnpoints';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { PracticeLoadDataService } from '../practice-load-detail/data/practice-load-data.service';
import { RouteService } from '../../../service/route.service';
import { Subscription } from 'rxjs';
import { ACKNOWLEDGEABLE_ERROR_STATUS_CODES, MAX_INT_32 } from '../../shared/constants/values';
import { DynamicGridComponent } from '../../shared/dynamic-grid/dynamic-grid.component';
@Component({
  selector: 'app-practice-log',
  templateUrl: './practice-log.component.html',
  styleUrl: './practice-log.component.scss',
})
export class PracticeLogComponent {
  toggleUrl: string;
  showPracticeLoadDetail: boolean = false;
  routes: string[];

  constructor(
    private http: HttpClient,
    private router: Router,
    private practiceLoadData: PracticeLoadDataService,
    private routeService: RouteService,
    private cdr: ChangeDetectorRef
  ) { }

  gridConfig: GridConfig = {
    columns: [
      {
        label: 'Acknowledge',
        jsonKey: 'isAcknowledged',
        dataType: 'toggle',
        toggleUrl: API_ENDPOINTS.PRACTICE_LOG_ACKNOWLEDGEMENT,
        isSortable: false,
      },
      { label: 'Practice Code', jsonKey: 'practiceCode', dataType: 'string' },
      {
        dataType: 'string',
        label: 'PMS Agent Version',
        jsonKey: 'pmsAgentVersion',
        isSortable: false,
      },
      { dataType: 'string', label: 'PMS Name', jsonKey: 'pmsName' },
      {
        label: 'Supported PMS Version',
        jsonKey: 'pmsVersion',
        dataType: 'string',
        isSortable: false,
      },
      {
        label: 'Latest PMS Version',
        jsonKey: 'latestPMSVersion',
        dataType: 'string',
      },
      {
        dataType: 'string',
        label: 'PMS Agent Status',
        jsonKey: 'pmsAgentStatus',
        isSortable: false
      },
      {
        dataType: 'text-wrap',
        label: 'Message',
        jsonKey: 'message',
        isSortable: false
      },
      {
        label: 'Resolution',
        jsonKey: 'resolution',
        dataType: 'string',
        width: 'full',
        isSortable: false,
      },
      {
        label: 'Created By',
        jsonKey: 'createdByUserEmail',
        dataType: 'string',
        hideOnToggle: true,
      },
      {
        dataType: 'date',
        label: 'Created At',
        jsonKey: 'createdAt',
        hideOnToggle: true,
      },
      {
        label: 'Modified By',
        jsonKey: 'modifiedByUserEmail',
        dataType: 'string',
        hideOnToggle: true,
      },
      {
        label: 'Modified At',
        jsonKey: 'modifiedAt',
        dataType: 'date',
        hideOnToggle: true,
      },
    ],
    filters: [
      {
        label: 'Practice',
        jsonKey: 'practiceId',
        type: 'multi',
        options: [],
        width: 'w-50',
      },
      {
        label: 'Status',
        jsonKey: 'status',
        type: 'multi',
        options: [],
        width: 'w-50',
      },
    ],
    displayHideAuditColumnsToggle: true,
    editable: false,
    deletable: false,
    uniqueTableName: 'PracticeErrorLog',
    showAllPagination: true,
  };

  actionDropdownConfig = {
    label: 'Actions',
    jsonKey: 'actions',
    type: 'single' as const,
    options: {
      data: [
        { id: 'acknowledgeAll', name: 'Acknowledge All Errors' },
        { id: 'deleteAcknowledged', name: 'Delete All Acknowledged' }
      ]
    },
    width: 'w-50'
  };

  getDataUrl: string = API_ENDPOINTS.PRACTICE_LOG;
  getPracticesUrl = API_ENDPOINTS.GETALLACTIVEPRACTICES;
  getStatusUrl = API_ENDPOINTS.PMS_STATUS;

  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild(DynamicGridComponent) dynamicGrid!: DynamicGridComponent;

  showAcknowledgeAllConfirmation = false;
  showDeleteAcknowledgedConfirmation = false;
  isProcessing = false;
  selectedAction: string = '';
  isActionDropdownOpen = false;

  ngOnInit() {
    this.fetchPracticeLoadOptions();
    this.fetchPMSStatusOptions();
  }

  fetchPracticeLoadOptions() {
    // Make an API call to fetch practice load options
    this.http
      .get<any>(this.getPracticesUrl)
      .subscribe((response) => {
        response.data = response.data
          .map((option) => ({
            ...option,
            name: option.practiceCode,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        response.data = [{ id: 'All', name: 'All Practices', checked: true }, ...response.data];
        this.gridConfig.filters.find(
          (filter) => filter.jsonKey === 'practiceId'
        ).options = response;
      });
  }

  fetchPMSStatusOptions() {
    // Make an API call to fetch practice load options
    this.http
      .get<any>(this.getStatusUrl)
      .subscribe((response) => {
        response.data = response.data
          .map((option) => ({
            ...option,
            name: option.source + " - " + (option.description || option.pmsAgentStatus),
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        response.data = response.data.filter((record) =>
          ACKNOWLEDGEABLE_ERROR_STATUS_CODES.includes(record.code || record.pmsStatusCode)
        ).sort((a, b) =>
          ACKNOWLEDGEABLE_ERROR_STATUS_CODES.indexOf(a.code || a.pmsStatusCode) - ACKNOWLEDGEABLE_ERROR_STATUS_CODES.indexOf(b.code || b.pmsStatusCode)
        );
        response.data = [{ id: 'All', name: 'All Statuses', checked: true }, ...response.data];
        this.gridConfig.filters.find(
          (filter) => filter.jsonKey === 'status'
        ).options = response;
      });
  }

  public routerSubscription: Subscription;

  ngAfterViewInit(): void {
    this.routerSubscription = this.routeService
      .getRoutes()
      .subscribe((data) => {
        this.routes = data;
        this.routes.shift();
        if (this.routes.length == 2) {
          this.routeService.redirectTO(
            this.routes.join('/').concat('/practice-error-logs')
          );
        }
        this.cdr.detectChanges();
      });
  }

  refreshHandler() {
    this.dynamicGrid.fetchData();
  }

  showToast(toast: Toast) {
    this.toastComponent.showToast(toast);
    this.refreshHandler();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  acknowledgeAllErrors() {
    this.showAcknowledgeAllConfirmation = true;
  }

  confirmAcknowledgeAll() {
    this.isProcessing = true;
    this.http.post(API_ENDPOINTS.PRACTICE_LOG_ACKNOWLEDGE_ALL, {}).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        this.showAcknowledgeAllConfirmation = false;
        this.showToast({
          severity: 'success',
          title: 'Success',
          message: response.data || 'All errors acknowledged successfully'
        });
      },
      error: (error) => {
        this.isProcessing = false;
        this.showAcknowledgeAllConfirmation = false;
        this.showToast({
          severity: 'error',
          title: 'Error',
          message: error?.error?.errorMessage || 'Failed to acknowledge all errors'
        });
      }
    });
  }

  cancelAcknowledgeAll() {
    this.showAcknowledgeAllConfirmation = false;
  }

  deleteAcknowledgedErrors() {
    this.showDeleteAcknowledgedConfirmation = true;
  }

  confirmDeleteAcknowledged() {
    this.isProcessing = true;
    this.http.delete(API_ENDPOINTS.PRACTICE_LOG_DELETE_ACKNOWLEDGED).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        this.showDeleteAcknowledgedConfirmation = false;
        this.showToast({
          severity: 'success',
          title: 'Success',
          message: response.data || 'All acknowledged errors deleted successfully'
        });
      },
      error: (error) => {
        this.isProcessing = false;
        this.showDeleteAcknowledgedConfirmation = false;
        this.showToast({
          severity: 'error',
          title: 'Error',
          message: error?.error?.errorMessage || 'Failed to delete acknowledged errors'
        });
      }
    });
  }

  cancelDeleteAcknowledged() {
    this.showDeleteAcknowledgedConfirmation = false;
  }

  toggleActionDropdown(event: Event) {
    event.stopPropagation();
    this.isActionDropdownOpen = !this.isActionDropdownOpen;
  }

  applyAction() {
    if (this.selectedAction === 'acknowledgeAll') {
      this.acknowledgeAllErrors();
    } else if (this.selectedAction === 'deleteAcknowledged') {
      this.deleteAcknowledgedErrors();
    }
    this.isActionDropdownOpen = false;
    this.selectedAction = '';
  }

  cancelAction() {
    this.selectedAction = '';
    this.isActionDropdownOpen = false;
  }
}